import React from 'react'

// "Requires Attention" — safety feature questions surfaced by adasThink.
// Answering a question cascades service status changes on the report
// (equipped → required, not-equipped → hidden, null → potential).
const SafetyFeatures = ({ report }) => {
  // Match Admin portal behavior: question list is based on services, not the
  // raw safetyFeatures array. This avoids over-rendering unrelated features.
  const services = (report.adas && report.adas.services) || []
  const potentialSensors = []
  const seen = new Set()
  services.forEach(svc => {
    // A service the shop REMOVED is off the report — its sensorAnswer must not
    // resurrect the sensor into this customer-facing card. A not-equipped
    // service stays: that is an answered "No", which the card shows with its
    // answer selected, same as the admin portal (#38204).
    if (svc.recommendedStatus === 'removed') return
    if ((svc.recommendedStatus === 'potential' || svc.sensorAnswer) && !seen.has(svc.sensorName)) {
      seen.add(svc.sensorName)
      potentialSensors.push(svc.sensorName)
    }
  })

  if (!potentialSensors.length) return null

  return (
    <div className='adas-detail__attention-card adas-detail__attention-card--readonly'>
      <div className='adas-detail__attention-header'>
        <h3 className='adas-detail__attention-title'>Requires Attention</h3>
        <p className='adas-detail__attention-subtitle'>
          Answering these questions will determine if &quot;Potential&quot; services are required.
        </p>
      </div>

      {potentialSensors.map((sensorName, idx) => {
        const currentService = services.find(s => s.sensorName === sensorName)
        const currentAnswer = (currentService && currentService.sensorAnswer) || null
        return (
          <div key={sensorName} className='adas-detail__attention-question'>
            <span className='adas-detail__question-text'>
              {idx + 1}. Is the vehicle equipped with {sensorName}?
            </span>
            <div className='adas-detail__question-actions'>
              <div className='adas-detail__radio-group'>
                <label className='adas-detail__radio'>
                  <input
                    type='radio'
                    name={`question-${sensorName}`}
                    checked={currentAnswer === 'equipped'}
                    disabled
                    readOnly
                  />
                  <span>Yes</span>
                </label>
                <label className='adas-detail__radio'>
                  <input
                    type='radio'
                    name={`question-${sensorName}`}
                    checked={currentAnswer === 'not-equipped'}
                    disabled
                    readOnly
                  />
                  <span>No</span>
                </label>
              </div>
              <span
                className='adas-detail__reset-link is-disabled'
              >
                Reset
              </span>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default SafetyFeatures
